import script from "./TheContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./TheContainer.vue?vue&type=script&setup=true&lang=js"

import "./TheContainer.vue?vue&type=style&index=0&id=d9fb8e82&scoped=true&lang=scss"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9fb8e82"]])

export default __exports__